import React from 'react';
import { Switch, Route, Redirect, useLocation, useParams } from 'react-router-dom';
import PrivateRoute from 'components/PrivateRoute';
import ShopifyInstall from 'packages/core-app/components/ShopifyInstall';

function ProjectRedirect() {
    const { projectId } = useParams();
    const { search } = useLocation();
    return <Redirect to={{ pathname: `/apps/${projectId}/app-builds`, search }} />;
}

// Project routes explicitly enable App Builds, Extensions, and Themes.
export default function BuildOnlyRoutes({ Dashboard, MyApps }) {
    const { search } = useLocation();
    return (
        <Switch>
            <PrivateRoute path="/apps/:projectId">
                <Dashboard />
            </PrivateRoute>
            <PrivateRoute path={['/:projectId/dashboard', '/old-dashboard/:projectId', '/:projectId/playground']}>
                <ProjectRedirect />
            </PrivateRoute>
            <Route exact path="/shopify-install" component={ShopifyInstall} />
            <PrivateRoute exact path="/">
                <MyApps />
            </PrivateRoute>
            <Redirect to={{ pathname: '/', search }} />
        </Switch>
    );
}
